"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _HBCalloutPopover = require("../HBCalloutPopover.styles");
var _HBPopoverActions = _interopRequireDefault(require("../../HBPopover/HBPopoverActions"));
var _HBText = _interopRequireDefault(require("../../HBText/HBText"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _templateObject;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getActionProperties = function getActionProperties(_ref, testIdName) {
  var text = _ref.text,
    onClick = _ref.onClick;
  return {
    text: text,
    onClick: onClick,
    testIdName: testIdName
  };
};
var HBCalloutPopoverActionsAndPagination = function HBCalloutPopoverActionsAndPagination(props) {
  var styles = props.styles,
    _props$primaryActionT = props.primaryActionType,
    primaryActionType = _props$primaryActionT === void 0 ? 'button' : _props$primaryActionT,
    actions = props.actions,
    primaryActionTestId = props.primaryActionTestId,
    secondaryActionTestId = props.secondaryActionTestId,
    actionsOrientation = props.actionsOrientation,
    stepsContent = props.stepsContent;
  var showLinkButton = primaryActionType === 'link-button' && actions.length > 0;
  var popoverActions = (0, _react.useMemo)(function () {
    if (showLinkButton || !(actions !== null && actions !== void 0 && actions.length)) {
      return [];
    }
    var _actions = [_objectSpread(_objectSpread({}, getActionProperties(actions[0], primaryActionTestId)), {}, {
      theme: styles.primaryActionTheme
    })];
    if (actions[1]) {
      _actions.unshift(_objectSpread(_objectSpread({}, getActionProperties(actions[1], secondaryActionTestId)), {}, {
        theme: styles.secondaryActionTheme
      }));
    }
    return _actions;
  }, [actions, primaryActionTestId, secondaryActionTestId, showLinkButton, styles.primaryActionTheme, styles.secondaryActionTheme]);
  if (!(actions !== null && actions !== void 0 && actions.length)) {
    return null;
  }
  var paginationContent = /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "subtitle12",
    color: "neutral700"
  }, "".concat(stepsContent === null || stepsContent === void 0 ? void 0 : stepsContent.currStep, " OF ").concat(stepsContent === null || stepsContent === void 0 ? void 0 : stepsContent.totalSteps));
  return showLinkButton ? /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.Footer, null, /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.LinkButton, {
    linkButtonTheme: styles.LinkButtonTheme,
    onClick: actions[0].onClick,
    testId: primaryActionTestId,
    iconPosition: "end",
    icon: /*#__PURE__*/_react["default"].createElement(_HBCalloutPopover.Arrow, {
      color: styles.textColor
    }),
    size: "sm"
  }, actions[0].text)) : /*#__PURE__*/_react["default"].createElement(ActionsAndPaginationWrapper, {
    $hasSteps: !!stepsContent
  }, !!stepsContent && paginationContent, /*#__PURE__*/_react["default"].createElement(_HBPopoverActions["default"], {
    actions: popoverActions,
    actionsOrientation: actionsOrientation,
    actionsAlignment: "right"
  }));
};
var _default = exports["default"] = HBCalloutPopoverActionsAndPagination;
var ActionsAndPaginationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutPopoverActionsAndPagination__ActionsAndPaginationWrapper",
  componentId: "sc-qezzod-0"
})(["", ""], (0, _styledIs["default"])('$hasSteps')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    "]))));
//# sourceMappingURL=HBCalloutPopoverActionsAndPagination.js.map